import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {Avatar, AVATAR_SIZES} from '@adv-mt/ui/avatar'
import {Body1, Body2} from '@adv-mt/ui/typography'

export const BASE_CLASS = 'mt-ContactFormV2-contactingAs'

const ContactingAs = ({userData}) => {
  const {i18n} = useContext(Context)

  if (!userData?.name) {
    return null
  }

  return (
    <div className={BASE_CLASS}>
      <Body1 as="span" highlight>
        {i18n.t('CONTACT_SELLER_V2.FORM.CONTACTING_AS')}
      </Body1>
      <div className={`${BASE_CLASS}-identity`}>
        <Avatar alt={userData.name} name={userData.name} size={AVATAR_SIZES.MEDIUM} src={userData.avatar} />
        <div className={`${BASE_CLASS}-text`}>
          <Body1 as="span" highlight>
            {userData.name}
          </Body1>
          <Body2 as="span">{userData.email}</Body2>
          {userData.phone && <Body2 as="span">{userData.phone}</Body2>}
        </div>
      </div>
    </div>
  )
}

ContactingAs.displayName = 'ContactFormV2ContactingAs'

ContactingAs.propTypes = {
  userData: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string
  })
}

export default ContactingAs
